export default "__VITE_ASSET__nSfRtuxY__"